import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";


const persistConfig = {
    key: "auth",
    storage,
    // Disable serializability check for Redux Persist
    blacklist: ['register'], 
  };
  
  const persistedReducer = persistReducer(persistConfig, authReducer);
  
  export const store = configureStore({
    reducer: { auth: persistedReducer },
    // Disable the serializability check globally
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST'],
        },
      }),
  });
  
  export const persistor = persistStore(store);
